module.exports = {
  "focusArea": [
      { label: "Cheek", value: 4 },
      { label: "Chin", value: 7 },
      { label: "Eyes", value: 5 },
      { label: "Forehead", value: 1 },
      { label: "Mouth", value: 3 },
      { label: "Neck", value: 6 },
      { label: "Nose", value: 2 },
      { label: "Overall", value: 8 },
  ],
  "articleType":[
    { label:'Skincare'},
    { label:'Makeup'},
    { label:'Inner Beauty'},
    { label:'Healthy Diet'},
    { label:'Face Yoga'},
  ]
}